import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * Sub-navigation strip that lives above the calendar grid:
 *   - Two tabs: Calendar / Find Appointment
 *   - Right side: "Saved Orders" count pill + a Select to jump back into
 *     any open draft invoice for the current branch.
 */
export default function CalendarSubnav({ tab, setTab, savedOrders, onSelectSavedOrder }) {
  return (
    <div className="flex items-center gap-6 border-b border-border pb-3 mb-4 flex-wrap" data-testid="calendar-subnav">
      <button
        type="button"
        onClick={() => setTab("calendar")}
        className={"pb-1 border-b-2 " + (tab === "calendar" ? "border-primary text-primary font-medium" : "border-transparent text-muted-foreground hover:text-foreground")}
        data-testid="subnav-calendar"
      >Calendar</button>
      <button
        type="button"
        onClick={() => setTab("find")}
        className={"pb-1 border-b-2 " + (tab === "find" ? "border-primary text-primary font-medium" : "border-transparent text-muted-foreground hover:text-foreground")}
        data-testid="subnav-find"
      >Find Appointment</button>

      <div className="ml-auto flex items-center gap-3">
        <div className="text-sm text-muted-foreground">
          Saved Orders <span className="inline-flex items-center justify-center min-w-[22px] h-5 px-1.5 rounded-full bg-primary/15 text-primary text-xs font-medium ml-1" data-testid="saved-orders-count">{savedOrders.length}</span>
        </div>
        <Select value="" onValueChange={onSelectSavedOrder}>
          <SelectTrigger className="w-[280px]" data-testid="saved-orders-select">
            <SelectValue placeholder="Select an Order to switch to it" />
          </SelectTrigger>
          <SelectContent>
            {savedOrders.length === 0 && <div className="p-3 text-xs text-muted-foreground">No saved orders</div>}
            {savedOrders.map((o) => (
              <SelectItem key={o.id} value={o.id}>
                #{o.id.slice(0, 6)} — {o.customer_name || "Walk-in"} · IDR {(o.total || 0).toLocaleString()}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
